// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bia_vu bia_ql bia_va bia_gy bia_kg bia_sv","ProfileAdminTools__item":"iz_b"};